/**
 * Loại công thức
 */
export default {
  //Hệ số
  Coefficient: 1,
  //Tỷ lệ
  Rate: 2,
  //Khác
  Other: 3
};

